import axios from "axios";
import qs from "qs";
import store from "@/store";
import error from "@/utils/error";
import router from "@/router";
import config from "@/config";
import { Modal } from "view-design";
const { TOKEN_NAME, timeout, version, baseUrl } = config;
let instance = axios.create({
  baseURL:
    process.env.NODE_ENV === "production" ? baseUrl : "/api",
  timeout,
  method: "POST",
  // headers: { "Content-Type": "application/x-www-form-urlencoded" },
  // `transformResponse` 在传递给 then/catch 前，允许修改响应数据
  transformRequest: [
    function(data) {
      // 对 data 进行任意转换处理
      // console.log(JSON.stringify(data));
      return qs.stringify(data);
    }
  ],
  data: {
    version,
    app_type: 3
  }
});
// 添加一个请求拦截器
instance.interceptors.request.use(
  config => {
    //添加token
    if (store.getters.token) {
      config.data["token"] = store.getters.token;
    }
    return config;
  },
  error => {
    // Do something with request error
    return Promise.reject(error);
  }
);

// 添加一个响应拦截器
instance.interceptors.response.use(
  function(response) {
    const data = response.data;
    const code = data.returncode,
      msg = data.returnmsg;
    if (code !== "0") {
      // token 过期了
      if (code === "051") {
        store.dispatch("resetToken").then(() => {
          Modal.confirm({
            title: "提示",
            content: "<p>登录已过期，是否重新登录</p>",
            onOk: () => {
              location.reload();
            }
          });
        });
      }
      // 排除002的提示
      if (code !== "002") {
        error(code, { [code]: msg });
      }
      return Promise.reject({ status: code, message: msg || "error" });
    } else {
      if (data.total_number) {
        return {
          data: data.data,
          pageSize: Number(data.pagesize), //每页条数
          total: Number(data.total_number), //总条数
          pageCount: Number(data.pages), //总页数
          current: Number(data.page) //当前页码
        };
      } else if (data.finish_id) {
        return {
          data: data.data,
          id: data.finish_id
        };
      } else {
        return data.data;
      }
    }
  },
  function(error) {
    console.log(error);
    let res = error.response;
    // console.log(error);
    if (res.status === 500) {
      //500 错误处理
      router.push({
        name: "error_500"
      });
    }
    // Do something with response error
    return Promise.reject({ status: res.status, message: res.statusText });
  }
);

export default instance;
